import staticUseContentful from '@ecm/effect/static/UseContentfulStatic'

export const appUseContentful = staticUseContentful

export default appUseContentful
